import { IconButton, Button, Tooltip, CircularProgress } from '@material-ui/core';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import AddIcon from '@material-ui/icons/Add';
import DOMPurify from 'dompurify';
import Authorize from 'components/Authorize';
import { permissionProfiles } from 'components/Authorize/permissionProfiles';
import NoteEditor from 'features/notes/NoteEditor';
import { NoteEntityTypes } from 'features/notes/notesConsts';
import { useGetEntityNotesQuery } from 'features/notes/notesSlice';
import { useState } from 'react';
import { hotNotePanelStyles } from './HotNotePanelStyles';
import { HOT_NOTE_MAX_CHARS } from './HotNotePanelConsts';

const HotNotePanel = ({ activityId }) => {
    const classes = hotNotePanelStyles();
    const [isEditing, setIsEditing] = useState(false);
    const [expanded, setExpanded] = useState(false);

    const { data: notes, isLoading, refetch } = useGetEntityNotesQuery(
        { entityId: activityId, entityType: NoteEntityTypes.ACTIVITY },
        { skip: !activityId }
    );

    const hotNote = notes?.find(n => n.isHotNote);

    const baseNote = {
        entityId: activityId,
        entityType: NoteEntityTypes.ACTIVITY,
        isHotNote: true,
    };

    return (
        <>
            <div className={classes.panel}>
                <div className={classes.label}>
                    <span>Hot Note</span>
                    {hotNote && (
                        <Authorize
                            profile={permissionProfiles.NOTES.EDIT_HOT_NOTE}
                            readonlyComponent={<></>}
                        >
                            <Tooltip title="Edit hot note">
                                <IconButton
                                    size="small"
                                    className={classes.editIconBtn}
                                    onClick={() => setIsEditing(true)}
                                >
                                    <EditOutlinedIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Authorize>
                    )}
                </div>

                {isLoading ? (
                    <CircularProgress size={14} />
                ) : hotNote ? (
                    <Tooltip title={expanded ? 'Click to collapse' : 'Click to expand'}>
                        <div
                            className={`${classes.content} ${expanded ? classes.contentExpanded : ''}`}
                            onClick={() => setExpanded(e => !e)}
                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(hotNote.content) }}
                        />
                    </Tooltip>
                ) : (
                    <Authorize
                        profile={permissionProfiles.NOTES.EDIT_HOT_NOTE}
                        readonlyComponent={<span className={classes.empty}>—</span>}
                    >
                        <Button
                            className={classes.addBtn}
                            startIcon={<AddIcon fontSize="small" />}
                            onClick={() => setIsEditing(true)}
                        >
                            Add hot note
                        </Button>
                    </Authorize>
                )}
            </div>

            {isEditing && (
                <NoteEditor
                    note={hotNote ? { ...hotNote, isHotNote: true } : baseNote}
                    onClose={() => setIsEditing(false)}
                    onSaved={refetch}
                    hideViewByClient={true}
                    maxLength={HOT_NOTE_MAX_CHARS}
                    suppressSuccessToast
                />
            )}
        </>
    );
};

export default HotNotePanel;
